import React from 'react';
import {
  TextButton,
  Icon,
  Text,
  TextButtonNotification,
  TextNotification,
} from '../styles';

const Button = ({
  children,
  onClick,
  disabled,
  btnIcon,
  noShadow,
  noBorder,
  btnHeight,
  btnWidth,
  iconWidth,
  iconHeight,
  variant,
  color,
}) => {
  const TextButtonComponent = variant === 'notification' ? TextButtonNotification : TextButton;
  const TextComponent = variant === 'notification' ? TextNotification : Text;
  return (
    <TextButtonComponent
      noShadow={noShadow}
      noBorder={noBorder}
      onClick={onClick}
      disabled={disabled}
      btnWidth={btnWidth}
      btnHeight={btnHeight}
      color={color}
    >
      {btnIcon && <Icon src={btnIcon} iconWidth={iconWidth} iconHeight={iconHeight} />}
      <TextComponent
        color={color}
      >
        {children}
      </TextComponent>
    </TextButtonComponent>
  );
};

export default Button;
